import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import {
  BusquedaCentroTrabajoDialogComponent,
  BusquedaProductoDialogComponent,
  InformacionEmpresaListadoBaseComponent
} from './informacion-empresa-listado-base.component';
import { InformacionEmpresaEjec } from 'src/app/domain/model/informacion-empresa/informacion-empresa-oc';
import { InformacionEmpresaRepository } from 'src/app/domain/service/informacion-empresa/informacion-empresa-repository';

@Component({
  selector: 'app-informacion-empresa-servicios-entregados',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    PaginatorModule,
    TableModule,
    TooltipModule,
    BusquedaProductoDialogComponent,
    BusquedaCentroTrabajoDialogComponent
  ],
  styleUrls: ['../shared/styles/grid-table.styles.scss'],
  template: `
    <div class="p-3 sm:p-6 max-w-6xl mx-auto">
      <div class="mb-4 flex items-center justify-between gap-2 flex-wrap">
        <div>
          <span class="text-sm text-gray-600 mb-2 flex items-center gap-2"
            >Información Empresa >><b> Servicios Entregados</b></span
          >
          <h1 class="text-xl sm:text-2xl font-bold text-gray-800 dark:text-gray-100">
            Servicios Entregados
          </h1>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Consulta de cumplimiento de servicios entregados asociados a la empresa.
          </p>
        </div>
        <a routerLink="/informacion-empresa" [queryParams]="queryParamsRegreso">
          <button
            pButton
            label="Regresar"
            icon="pi pi-arrow-left"
            severity="secondary"
            class="p-button-outlined"
          ></button>
        </a>
      </div>

      <div
        class="rounded-lg border border-orange-200 bg-orange-100 p-4 text-orange-900 mb-4"
      >
        <div class="font-semibold mb-2">Contexto de consulta</div>
        <div class="text-sm grid grid-cols-1 gap-2">
          <div class="rounded px-3 py-2 border border-orange-100">
            <span class="font-medium">Cliente seleccionado:</span>
            <span class="ml-2">{{ nombreCliente() }}</span>
          </div>
          <div class="rounded px-3 py-2 border border-orange-100">
            <span class="font-medium">Consultor seleccionado:</span>
            <span class="ml-2">{{ nombreConsultor() }}</span>
          </div>
        </div>
      </div>

      <div
        class="border border-gray-200 dark:border-gray-700 rounded p-4 mb-4 bg-gray-50 dark:bg-gray-800"
      >
        <div class="font-medium text-gray-700 dark:text-gray-200 mb-3 text-sm">
          Filtros
        </div>

        <div class="grid grid-cols-1 gap-3">
          <div>
            <label
              for="filtroAno"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Año <span class="text-red-500">*</span>
            </label>
            <input
              id="filtroAno"
              pInputText
              [(ngModel)]="filtroAno"
              maxlength="4"
              class="w-full"
              placeholder="Ej: 2026"
              (input)="onAnoInput($event)"
            />
          </div>

          <div>
            <label
              for="filtroCumplimiento"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Cumplimiento
            </label>
            <input
              id="filtroCumplimiento"
              pInputText
              [(ngModel)]="filtroCumplimiento"
              maxlength="11"
              class="w-full"
              placeholder="Ingrese cumplimiento"
              (input)="onCumplimientoInput($event)"
            />
          </div>

          <div>
            <label
              for="filtroProducto"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Producto
            </label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input
                id="filtroProducto"
                pInputText
                [value]="productoSeleccionadoLabel()"
                class="flex-1 min-w-0"
                readonly
              />
              <button
                pButton
                icon="pi pi-search"
                class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                severity="primary"
                size="small"
                pTooltip="Buscar producto"
                tooltipPosition="left"
                (click)="abrirBusquedaProducto()"
              ></button>
              @if (productoSeleccionado()) {
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger"
                  size="small"
                  pTooltip="Limpiar producto"
                  tooltipPosition="left"
                  (click)="limpiarProducto()"
                ></button>
              }
            </div>
          </div>

          <div>
            <label
              for="filtroOficina"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Oficina <span class="text-red-500">*</span>
            </label>
            <p-dropdown
              inputId="filtroOficina"
              [options]="oficinas()"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filtroOficina"
              [filter]="true"
              [showClear]="false"
              [style]="{ width: '100%' }"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div>
            <label
              for="filtroCentroTrabajo"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Centro de Trabajo
            </label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input
                id="filtroCentroTrabajo"
                pInputText
                [value]="centroTrabajoSeleccionadoLabel()"
                class="flex-1 min-w-0"
                readonly
              />
              <button
                pButton
                icon="pi pi-search"
                class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                severity="primary"
                size="small"
                pTooltip="Buscar centro de trabajo"
                tooltipPosition="left"
                (click)="abrirBusquedaCentroTrabajo()"
              ></button>
              @if (centroTrabajoSeleccionado()) {
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger"
                  size="small"
                  pTooltip="Limpiar centro de trabajo"
                  tooltipPosition="left"
                  (click)="limpiarCentroTrabajo()"
                ></button>
              }
            </div>
          </div>
        </div>

        <div class="mt-4 flex flex-wrap justify-end sm:justify-start gap-3 w-full">
          <button
            pButton
            label="Limpiar"
            icon="pi pi-eraser"
            class="p-button-outlined"
            severity="secondary"
            (click)="limpiarFiltros()"
          ></button>
          <button pButton label="Buscar" icon="pi pi-search" (click)="buscar()"></button>
        </div>
      </div>

      @if (mensaje()) {
        <div class="p-3 mt-4 rounded" [ngClass]="mensajeClass()">
          {{ mensaje() }}
        </div>
      }

      <div class="mt-4">
        <div class="md:hidden space-y-3">
          @if (!loading() && items().length === 0) {
            <div class="text-center p-4 text-gray-500 border border-gray-200 dark:border-gray-700 rounded-lg">
              No se encontraron resultados para los filtros enviados.
            </div>
          }

          @for (item of items(); track $index) {
            <div class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-900">
              <div class="grid grid-cols-1 gap-2 text-sm">
                <div><span class="text-gray-500">Código Producto:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.cdproducto || '-' }}</span></div>
                <div><span class="text-gray-500">Producto:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsproducto || '-' }}</span></div>
                <div><span class="text-gray-500">Hrs. Ejec. Campo:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nmcantidaejeccamp ?? 0 }}</span></div>
                <div><span class="text-gray-500">Hrs. Ejec. Informe:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nmcantidaejecinf ?? 0 }}</span></div>
                <div><span class="text-gray-500">Oficina:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsoficina || '-' }}</span></div>
              </div>
              <div class="mt-3">
                <p-button label="Ver detalle" icon="pi pi-eye" severity="secondary" [outlined]="true" size="small" styleClass="w-full min-h-[44px]" (onClick)="verDetalle(item)"></p-button>
              </div>
            </div>
          }
        </div>

        <div class="hidden md:block">
        <p-table
          [resizableColumns]="true"
          columnResizeMode="expand"
          [value]="items()"
          [loading]="loading()"
          responsiveLayout="scroll"
          styleClass="tabla-informacion-empresa p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" [tableStyle]="{ 'min-width': '72rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn>Código Producto</th>
              <th pResizableColumn>Producto</th>
              <th pResizableColumn>Hrs. Ejec. Campo</th>
              <th pResizableColumn>Hrs. Ejec. Informe</th>
              <th pResizableColumn>Oficina</th>
              <th pResizableColumn>Ver Detalle</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.cdproducto || '-' }}</td>
              <td>{{ item.dsproducto || '-' }}</td>
              <td>{{ item.nmcantidaejeccamp ?? 0 }}</td>
              <td>{{ item.nmcantidaejecinf ?? 0 }}</td>
              <td>{{ item.dsoficina || '-' }}</td>
              <td>
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-text p-button-sm"
                  pTooltip="Ver detalle"
                  aria-label="Ver detalle"
                  tooltipPosition="left"
                  (click)="verDetalle(item)"
                ></button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center p-6 text-gray-500">
                No se encontraron resultados para los filtros enviados.
              </td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </div>

      <div class="mt-4 flex justify-end">
        <p-paginator
          [rows]="rows()"
          [first]="first()"
          [totalRecords]="totalRecords()"
          [rowsPerPageOptions]="[10, 20, 50]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
          dropdownAppendTo="body"
          appendTo="body"
          (onPageChange)="onPageChange($event)"
        ></p-paginator>
      </div>

      @if (mostrarBuscadorProducto) {
        <app-busqueda-producto-dialog
          (onSelect)="onProductoSeleccionado($event)"
          (onClose)="cerrarBusquedaProducto()"
        ></app-busqueda-producto-dialog>
      }

      @if (mostrarBuscadorCentroTrabajo) {
        <app-busqueda-centro-trabajo-dialog
          [titulo]="'Búsqueda de Centro de Trabajo'"
          [nmconsecutivoBeneficiario]="idBeneficiario()"
          [nombreBeneficiario]="nombreCliente()"
          [cargarAlAbrir]="true"
          (onSelect)="onCentroTrabajoSeleccionado($event)"
          (onClose)="cerrarBusquedaCentroTrabajo()"
        ></app-busqueda-centro-trabajo-dialog>
      }
    </div>
  `
})
export class InformacionEmpresaServiciosEntregadosComponent extends InformacionEmpresaListadoBaseComponent<InformacionEmpresaEjec> {
  private readonly informacionEmpresaRepository = inject(InformacionEmpresaRepository);

  filtroCumplimiento = '';

  override readonly idAsesor = computed(() =>
    this.toNumber(this.route.snapshot.queryParamMap.get('nmconsecutivoConsultor'))
    ?? this.toNumber(this.route.snapshot.queryParamMap.get('cdpersonaConsultor'))
  );

  override limpiarFiltros(): void {
    super.limpiarFiltros();
    this.filtroCumplimiento = '';
  }

  onCumplimientoInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorNumerico = input.value.replace(/\D/g, '').slice(0, 11);
    this.filtroCumplimiento = valorNumerico;
    input.value = valorNumerico;
  }

  protected override validarFiltros(mostrarError = true): boolean {
    const anoValido = /^\d{4}$/.test(this.filtroAno);
    const cumplimientoValido = this.filtroCumplimiento.length <= 11;

    if (!anoValido || !this.filtroOficina || !cumplimientoValido) {
      if (mostrarError) {
        this.mensajeTipo.set('warning');
        this.mensaje.set('Año (4 dígitos) y oficina son obligatorios. Cumplimiento debe ser numérico de hasta 11 dígitos.');
      }
      return false;
    }

    return true;
  }

  protected async consultar(first: number, rows: number): Promise<void> {
    this.loading.set(true);
    this.mensaje.set('');
    const inudesde = first + 1;
    const inuhasta = first + rows;

    try {
      const resultado = await this.informacionEmpresaRepository.listarServiciosEntregados({
        inuano: Number(this.filtroAno),
        inuproducto: this.productoSeleccionado()
          ? Number(this.productoSeleccionado()?.cdproducto)
          : undefined,
        inuoficina: this.filtroOficina ?? undefined,
        inubeneficiario: this.idBeneficiario() ?? undefined,
        inucentrotrabajo: this.centroTrabajoSeleccionado()?.nmconsecutivo,
        inuasesor: this.idAsesor() ?? undefined,
        inuCumplimiento: this.filtroCumplimiento ? Number(this.filtroCumplimiento) : undefined,
        inudesde,
        inuhasta
      });

      this.items.set(resultado);
      this.totalRecords.set(resultado[0]?.totalregistro ?? 0);
      if (resultado.length === 0) {
        this.mensajeTipo.set('info');
        this.mensaje.set('No se recuperó información con los parámetros ingresados.');
      }
    } catch {
      this.items.set([]);
      this.totalRecords.set(0);
      this.mensajeTipo.set('error');
      this.mensaje.set('Error consultando Servicios Entregados.');
    } finally {
      this.loading.set(false);
    }
  }

  productoDisplay(item: InformacionEmpresaEjec): string {
    const codigo = item.cdproducto?.trim() ?? '';
    const descripcion = item.dsproducto?.trim() ?? '';

    if (codigo && descripcion) {
      return `${codigo} - ${descripcion}`;
    }
    return codigo || descripcion || '-';
  }

  async verDetalle(item: InformacionEmpresaEjec): Promise<void> {
    await this.router.navigate(['/informacion-empresa/servicios-entregados/detalle'], {
      queryParams: {
        ...this.queryParamsRegreso,
        cdproductoSeleccionado: item.cdproducto ?? undefined,
        dsproductoSeleccionado: item.dsproducto ?? undefined,
        cdoficinaSeleccionada: item.cdoficina ?? undefined,
        dsoficinaSeleccionada: item.dsoficina ?? undefined,
        anioSeleccionado: this.toNumber(this.filtroAno) ?? undefined,
        cumplimientoSeleccionado: this.filtroCumplimiento
          ? Number(this.filtroCumplimiento)
          : undefined
      }
    });
  }
}
